export const VIEW_SATISFINDER_PROFILES = 'view_satisfinder_profiles';

export const hasPermission = (user, permission) =>
  user?.role === 'platform_admin' || (user?.permissions || []).includes(permission);
